import { makeStyles } from '@material-ui/core/styles';
import { flexAlignCenter } from 'UI/utils/styles';

export const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(2, 4, 4)
  },
  titleContainer: {
    ...flexAlignCenter,
    gap: theme.spacing(2),
    padding: theme.spacing(4, 4, 2)
  },
  title: {
    flex: 1
  },
  bodyContainer: {
    padding: theme.spacing(2, 4)
  },
  dialogPaper: {
    top: 'initial',
    padding: 0,
    borderBottom: ({ color }) => `10px solid ${color}`
  },
  button: {
    minWidth: 120,
    fontWeight: theme.typography.fontWeightMedium
  },
  buttonMargin: {
    margin: theme.spacing(0, 2)
  },
  children: {
    margin: theme.spacing(1, 0)
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200
  },
  customActionsContainer: {
    '& > *': {
      margin: theme.spacing(0, 1)
    }
  }
}));
